import axios from "axios"
import { env } from '../constants'


/* The token of the administrator goes with every call */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* GET — the settings of the platform and how every Whatsapp template is doing */
export const get = data => {
    const uri = `${env.startpoint}/admin/settings/get`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}

/* SAVE — one setting: { name, value } */
export const save = data => {
    const uri = `${env.startpoint}/admin/settings/save`
    return axios.post(uri, data, auth()).then(response => response).catch(error => error.response)
}
